import { Link } from "react-router-dom";

// Editable copy — replace before launch.
export default function About() {
  return (
    <div className="hbe-container py-16 md:py-24 max-w-3xl" data-testid="about-page">
      <div className="hbe-eyebrow">About HBE</div>
      <h1 className="mt-3 font-serif text-4xl md:text-5xl">
        Private yacht entertainment, quietly done.
      </h1>
      <div className="mt-8 space-y-6 text-hbe-ink/80 text-base md:text-lg leading-relaxed">
        <p>
          HBE Entertainment operates a small fleet of private yachts in Miami.
          Every reservation is a full-yacht booking — one group, one boat, one
          contact from start to finish. We keep the experience simple, the
          pricing clear, and the details handled.
        </p>
        <p>
          Whether the day is a milestone birthday, a proposal, a client
          gathering, or an afternoon on the water because it's a good idea,
          the format is the same: your people, your time, our boat.
        </p>
      </div>

      <div className="mt-12">
        <Link to="/yachts" className="hbe-btn-primary" data-testid="about-cta">
          See the fleet
        </Link>
      </div>
    </div>
  );
}
